import axios from "axios";
import { DTMWebAPIClient } from "./DTMWebAPIClient.generated";

const DEFAULT_TIMEOUT = 60000;
let API_URL: string | undefined = undefined;

export interface APIConfig {
  timeout?: number;
  endpoint?: string;
  token?: string;
}

export const createApiClient = (config: APIConfig) => {

  if (API_URL === undefined) {
    const apiBase = document.querySelector('meta[data-api-base]')?.dataset?.apiBase;
    if (apiBase) {
      API_URL = apiBase;
    }
  }

  const myAxios = axios.create({
    timeout: config.timeout ?? DEFAULT_TIMEOUT,
    withCredentials: false,
    headers: config.token ? {
      "Content-Type": "application/json",
      "Authorization" : "Bearer " + config.token
    } : {
      "Content-Type": "application/json",
    },
  });

  return new DTMWebAPIClient(API_URL, myAxios);
};